/**
 * Zentrale IDs der Navigations-Buttons.
 *
 * Werden sowohl im Route-Data-Modell (app-routing.module) als auch beim
 * Enable/Disable ueber den buttonStates-Store (AppNavigationActions) referenziert.
 * IDs muessen eindeutig sein, da der buttonStates-Store nach ID keyt.
 */
export const NavButtonIds = {
  createRechnung: 'create-rechnung',
  createLieferschein: 'create-lieferschein',
  createAngebot: 'create-angebot',
  createGutschrift: 'create-gutschrift',
} as const;
